<template>
  <div class="relative min-h-[59px] h-full w-full overflow-hidden">
    <transition name="slide">
      <div
        v-if="isFirstActive"
        class="absolute inset-0 flex items-center"
        :class="wrapperClass"
      >
        <slot name="first" />
      </div>
    </transition>
    <transition name="slide">
      <div
        v-if="!isFirstActive"
        class="absolute inset-0 flex items-center"
        :class="wrapperClass"
      >
        <slot name="second" />
      </div>
    </transition>
  </div>
</template>

<script setup>
defineProps({
  isFirstActive: {
    type: Boolean,
    default: true,
  },
  wrapperClass: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  @apply transition-[opacity,transform] duration-200;
}
.slide-enter-from {
  @apply opacity-0 -translate-y-24;
}
.slide-leave-to {
  @apply opacity-0 translate-y-24;
}
</style>
